import { isMobile, deviceType, isTablet, isMobileSafari, isIOS } from "mobile-device-detect";

/** Geräteerkennung gemäß https://stackoverflow.com/a/58017456 */
export function isComputer() {
    if (isMobile) { return false; }
    if (isTablet) { return false; }
    if (isMobileSafari) { return false; }
    if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) { return false; }
    return true;
}

export function isIpad() {
    return navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
}